import { Box } from '@quintoandar-tokko/jopijs';
import React from 'react';
import { useSelector } from 'react-redux';
import UnassignedInquiryCard from './UnassignedInquiryCard';
import styles from './unassignedInquiries.module.scss';
import { showCardSeparator } from '../utils';

function UnassignedInquiriesContainer({ trackCallback = null }) {
  const { inquiries } = useSelector(
    (state) => state.DashboardSlice.unassignedInquiries
  );
  return (
    <Box className={styles.unassignedInquiriesContainer}>
      {inquiries.map((inquiry, index) => (
        <Box key={inquiry.id}>
          <UnassignedInquiryCard
            inquiry={inquiry}
            trackCallback={trackCallback}
          />
          {showCardSeparator(index, inquiries) && (
            <Box className={styles.separator} />
          )}
        </Box>
      ))}
    </Box>
  );
}

export default UnassignedInquiriesContainer;
